import CallIcon from '@mui/icons-material/Call';
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { externalNavigate } from '../helpers';
import { ScrollContext } from '../App';
import './ResponsiveAppBar.css';
import logo from '../images/logos/ecv_logo.png';


function Logo(props) {
  return (
    <Box sx={{ ...props.sx, alignItems: 'center', padding: '10px' }}>
      <a href='/' style={{ display: 'contents' }} >
        <img id='logo-image' src={logo} alt='logo' style={{ maxHeight: '100px', width: 'auto' }}></img>
      </a>
    </Box >
  )
}


function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const navigate = useNavigate();
  const { isScrolled, alwaysShowBackground } = useContext(ScrollContext);

  // Calculate opacity based on scroll position (0-1)
  const scrollOpacity = Math.min(isScrolled / 200, 1);

  const pages = [
    { name: 'Gallery', url: '/gallery' }
  ];

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };



  return (
    <AppBar sx={{ 
      position: { xs: 'fixed', md: 'fixed' }, 
      backgroundColor: alwaysShowBackground 
        ? 'primary.main' 
        : `rgba(223, 111, 91, ${scrollOpacity})`,
      zIndex: 1100,
      borderBottom: 'none',
      boxShadow: 'none'
    }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Logo sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
                "& .MuiMenu-paper":
                  { backgroundColor: "secondary.main", }
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page.name} onClick={() => { handleCloseNavMenu(); navigate(page.url) }}>
                  <Typography textAlign="center">{page.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Logo sx={{ display: { xs: 'flex', md: 'none' }, marginLeft: 'auto', marginRight: 'auto', alignContent: 'center' }} />

          <Box sx={{ marginLeft: 'auto', display: { xs: 'none', md: 'flex', } }}>
            {pages.map((page) => (
              <Button
                key={page.name}
                onClick={() => { handleCloseNavMenu(); navigate(page.url) }}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page.name}
              </Button>
            ))}
          </Box>
          <Box sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' } }}>
            <IconButton onClick={() => { externalNavigate('tel:813-215-3262') }} sx={{ color: '#ffffff' }}><CallIcon /></IconButton>
          </Box>

        </Toolbar>
      </Container>
    </AppBar >
  );
}
export default ResponsiveAppBar;